<template>
	<div id="app">
		<router-view :key="$route.fullPath" />
	</div>
</template>

<script>
	export default {
		name: 'App',
		components: {},
		created() {
			if(!sessionStorage.getItem('token')){
				this.$router.push('/login')
			}
			
			document.title='消安天天查数据监管系统'
			sessionStorage.setItem('provinceCode', '');
			sessionStorage.setItem('cityCode', '');
			sessionStorage.setItem('districtCode', '');
			sessionStorage.setItem('townshipCode', '');
			sessionStorage.setItem('startDate', '');
			sessionStorage.setItem('endDate', '');
		}
	}
</script>

<style>
	#app {
		font-family: Avenir, Helvetica, Arial, sans-serif;
		-webkit-font-smoothing: antialiased;
		-moz-osx-font-smoothing: grayscale;
		text-align: center;
		color: #2c3e50;
		padding: 0;
		margin: 0;
	}
	/* 整个页面的滚动条 */
::-webkit-scrollbar {
  width: 0px;   /* 竖向滚动条宽度 */
  height: 10px;  /* 横向滚动条高度 */
}

/* 滚动条轨道 */
::-webkit-scrollbar-track {
  background: #f1f1f1;
  border-radius: 10px;
}

/* 滚动条滑块 */
::-webkit-scrollbar-thumb {
  background: #c1c1c1;
  border-radius: 10px;
  transition: background 0.3s;
}

/* 滑块 hover 状态 */
::-webkit-scrollbar-thumb:hover {
  background: #a1a1a1;
}

/* 滚动条角落 */
::-webkit-scrollbar-corner {
  background: transparent;
}
</style>